import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionKubPage = ({ path }) => (
  <>
    <Meta
      title="ATC Digital Business Solutions | Kubernetes Consulting Services and Solutions Provider"
      description="ATC's Kubernetes cloud services help you adopt Kubernetes to maximize the speed, cost-efficiencies, and scalability of your cloud-native adoption journey."
    />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="solutions/kubernetes-banner.jpg"
          title="Kubernetes - Cloud Scaling. Professional Services."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            Discover the benefits of faster application development, delivery,
            and scale with Kubernetes.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Learn how to get started</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">Cloud Native Guidance</h2>
                <p className="white-txt">
                  You’re already running your business applications through the
                  cloud. Now, manually updating your apps through numerous
                  servers is unnecessary. Reduce complex applications to
                  manageable microservices. When your apps achieve scale, you
                  need a mechanism to automatically and rapidly deploy
                  containers so that your end users have a seamless experience.
                  Utilizing Kubernetes allows you to update all aspects of your
                  applications seamlessly in one pass, cutting down your
                  maintenance time and allowing you to focus on what’s
                  important, business.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps id="kubernetes" flyText="Kubernetes" flyBoxImage="solutions/kubernetes-box.jpg" />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Kubernetes: Open-Source Container Orchestration Tool by Google
                </h2>
                <p>
                  As the number of applications grows, enterprises are faced
                  with the overhead of supporting underutilized infrastructure.
                  By using containers, you can consolidate your applications
                  with fewer resources which will increase the utilization of
                  your existing infrastructure. Containers can also make your
                  applications portable and by using Kubernetes as the
                  orchestration engine you get the flexibility of deploying your
                  applications on public or private clouds with minimum
                  disruption.
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    Benefits of
                    <br />
                    Kubernetes
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Scale</h3>
                        <p>Scale without affecting resources.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Versatility</h3>
                        <p>
                          On-premise, hybrid, or public cloud options available.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Delivery</h3>
                        <p>
                          Deliver complex applications consistently and easily.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Support</h3>
                        <p>24/7 Enterprise Kubernetes Support.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionKubPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionKubPage;
